import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import useOidcService from "../../hooks/auths/useOidcService";

export default function LogoutCallback() {
  const { handleSignoutCallback } = useOidcService();
  const navigate = useNavigate();
  useEffect(() => {
    handleSignoutCallback()
      .then(() => {
        navigate("/");
      })
  }, [handleSignoutCallback, navigate]);

  return (<></>);
}
